interface IPagination {
    totalPage: number
    currentPage: number
    onClick: (idx: number) => void
}

const Pagination = ({ totalPage, currentPage, onClick }: IPagination) => {
    if (totalPage <= 1) return <></>;

    const maxVisible = 10
    const half = Math.floor(maxVisible / 2)

    let start = currentPage - half + 1
    let end = start + maxVisible - 1

    // 시작/끝 조정
    if (start < 1) {
        start = 1
        end = Math.min(totalPage, maxVisible)
    } else if (end > totalPage) {
        end = totalPage
        start = Math.max(1, totalPage - maxVisible + 1)
    }

    const pages = Array.from({ length: end - start + 1 }, (_, i) => start + i)

    const goToTop = () => {
        window.scrollTo({
            top: 0,
            behavior: "smooth"
        })
    }

    return (
        <div className='flex justify-center items-center gap-2 pb-4 select-none'>
            {
                pages.map((page, idx) => (
                    <div
                        className={`flex items-center justify-center w-7.5 h-7.5 rounded-full cursor-pointer transition-all ${currentPage === page ? 'bg-primary text-white ' : ' text-black'} hover:bg-primary hover:text-white `}
                        key={idx}
                        onClick={() => {
                            goToTop()
                            onClick(page - 1)
                        }}
                    >
                        {page}
                    </div>
                ))
            }
        </div>
    )
}

export default Pagination